import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/integrations/supabase/client";
import { Skeleton } from "@/components/ui/skeleton";

interface Guide {
  id: string;
  title: string;
  content: string;
  media_urls: string[];
  category_id: string | null;
  help_categories: {
    name: string;
  } | null;
}

export function GuidesSection() {
  const { data: guides, isLoading } = useQuery({
    queryKey: ["guides"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("guides")
        .select(`
          id,
          title,
          content,
          media_urls,
          category_id,
          help_categories (
            name
          )
        `)
        .eq("is_published", true);

      if (error) throw error;
      return data as Guide[];
    },
  });

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i}>
            <CardHeader>
              <Skeleton className="h-6 w-3/4" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-24 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {guides?.map((guide) => (
        <Card key={guide.id}>
          <CardHeader>
            <CardTitle>{guide.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="prose dark:prose-invert">
              {guide.content}
            </div>
            {guide.media_urls && guide.media_urls.length > 0 && (
              <div className="mt-4 space-y-2">
                {guide.media_urls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Guide illustration ${index + 1}`}
                    className="rounded-lg"
                  />
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}